import { render, staticRenderFns } from "./dialog-success.vue?vue&type=template&id=79d69af5&"
import script from "./dialog-success.vue?vue&type=script&lang=js&"
export * from "./dialog-success.vue?vue&type=script&lang=js&"
import style0 from "./dialog-success.vue?vue&type=style&index=0&id=79d69af5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports